export default "__VITE_ASSET__TZ0p9GdF__"